import { cn as e } from "../../shared/utils.js";
import { Button as t } from "../../button/primitive/button.js";
import { useTranslation as n } from "../../i18n/hooks.js";
import { Skeleton as r } from "../../skeleton/skeleton.js";
import { Checkbox as i } from "../../checkbox/primitive/index.js";
import { TableSelectionActionsProvider as a, useTableSelectionActions as o } from "./selection-actions-context.js";
import { TableSelectionProvider as s, useTableSelection as c } from "./selection-context.js";
import { useEffect as l } from "react";
import { jsx as u, jsxs as d } from "react/jsx-runtime";
//#region src/table/primitive/mobile.tsx
var f = ({ className: t, onClearSelection: n, onSelectionChange: r, onSelectAll: i, selectedKeys: o, selectionMode: c = "none", ...l }) => /* @__PURE__ */ u(a, {
	onClearSelection: n,
	onSelectAll: i,
	children: /* @__PURE__ */ u(s, {
		selectedKeys: o,
		selectionMode: c,
		onSelectionChange: r,
		children: /* @__PURE__ */ u("div", {
			className: e("flex flex-col", t),
			...l
		})
	})
});
f.displayName = "Table.Mobile.Root";
var p = ({ allowSelectAll: r = !0, children: i, className: a, ...s }) => {
	let { t: l } = n(), { isSomeRowSelected: f, onDeselectEveryRow: p, onSelectEveryRow: m, rowCount: h, selectionMode: g } = c(), { onClearSelection: _, onSelectAll: v } = o(), y = g === "multiple";
	return /* @__PURE__ */ d("div", {
		className: e("flex flex-col gap-2 p-1", a),
		...s,
		children: [i, y ? /* @__PURE__ */ d("div", {
			className: "flex w-full items-center justify-between gap-2",
			children: [r ? /* @__PURE__ */ u(t, {
				size: "sm",
				variant: "ghost-color",
				disabled: h === 0,
				onClick: () => (v ?? m)(),
				children: l("public_pages_purchase.table.mobile.select_all")
			}) : /* @__PURE__ */ u("span", {}), f && /* @__PURE__ */ u(t, {
				size: "sm",
				variant: "ghost-gray",
				onClick: () => (_ ?? p)(),
				children: l("public_pages_purchase.table.mobile.cancel")
			})]
		}) : null]
	});
};
p.displayName = "Table.Mobile.Header";
var m = ({ className: t, ...n }) => /* @__PURE__ */ u("div", {
	className: e("flex flex-col", t),
	...n
});
m.displayName = "Table.Mobile.Body";
var h = ({ children: t, className: r, id: a, ...o }) => {
	let { t: s } = n(), { isSelected: f, onToggle: p, registerRow: m, selectionMode: h } = c(), g = h !== "none" && a != null, _ = a != null && f(a);
	return l(() => {
		if (!(!g || a == null)) return m(a);
	}, [
		a,
		g,
		m
	]), /* @__PURE__ */ u("article", {
		"data-selected": _ || void 0,
		className: e("bg-bg-primary border-table-cell-border gap-4 px-4 py-3 not-last:border-b", "hover:bg-table-cell-bg-hover data-[selected=true]:bg-table-cell-bg-selected data-[selected=true]:hover:bg-table-cell-bg-selected", r),
		...o,
		children: g ? /* @__PURE__ */ d("div", {
			className: "flex items-start gap-3",
			children: [/* @__PURE__ */ u(i.Root, {
				"aria-label": typeof a == "string" ? s("public_pages_purchase.table.mobile.select_row_named", { row: a }) : s("public_pages_purchase.table.mobile.select_row"),
				checked: _,
				size: "lg",
				onCheckedChange: () => a != null && p(a),
				children: /* @__PURE__ */ u(i.Indicator, { size: "lg" })
			}), /* @__PURE__ */ u("div", {
				className: "flex min-w-0 flex-1 flex-col gap-3",
				children: t
			})]
		}) : /* @__PURE__ */ u("div", {
			className: "flex flex-col gap-3",
			children: t
		})
	});
};
h.displayName = "Table.Mobile.Card";
var g = ({ className: t, label: n, children: r, ...i }) => /* @__PURE__ */ d("div", {
	className: e("text-text-secondary flex items-center justify-between gap-4 text-base font-normal", t),
	...i,
	children: [n ? /* @__PURE__ */ u("div", {
		"data-slot": "label",
		className: "text-table-header-text shrink-0",
		children: n
	}) : null, /* @__PURE__ */ u("div", {
		"data-slot": "value",
		className: "text-text-primary min-w-0 truncate text-right",
		children: r
	})]
});
g.displayName = "Table.Mobile.Cell";
var _ = ({ children: t, className: n, ...i }) => /* @__PURE__ */ u(g, {
	className: e("*:data-[slot=value]:flex-1", n),
	...i,
	children: t ?? /* @__PURE__ */ u(r, { className: "h-3.5 w-full" })
});
_.displayName = "Table.Mobile.LoaderCell";
var v;
(function(e) {
	e.Root = f, e.Header = p, e.Body = m, e.Card = h, e.Cell = g, e.LoaderCell = _;
})(v ||= {});
//#endregion
export { v as TableMobile };
